import { object, ObjectSchema, string } from 'yup';

export const projectNameError =
  'Must start with a letter and end with a letter or number. Can contain letters, numbers, spaces, hyphens, and underscores.';

export const projectNameSchema = string()
  .required('This field is required')
  .max(40, 'Must be less than 40 characters')
  .matches(/^[a-zA-Z][ a-zA-Z0-9_-]*[a-zA-Z0-9]$/, {
    excludeEmptyString: true,
    message: projectNameError,
  });

export const apiKeyNicknameSchema = string()
  .required('This field is required')
  .min(2, 'Must be a minimum of 2 characters')
  .max(50, 'Must be less than 50 characters')
  .matches(/^[A-Za-z][A-Za-z0-9\-_]*$/, {
    excludeEmptyString: true,
    message:
      'Must begin with a letter and can only contain letters, numbers, hyphens, and underscores',
  });

// matches notification service email validation
export const validEmailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/i;

export function generateProjectNameSchema(
  fields: Record<string, any>,
  existingNames?: string[],
): ObjectSchema<any> {
  const objShape = Object.keys(fields).reduce((acc, field) => {
    acc[field] = projectNameSchema.test(
      'is-unique',
      'Project name already exists',
      (value) => !existingNames?.includes(value),
    );
    return acc;
  }, {});

  return object().shape(objShape);
}

export function isHttpsUrl(urlStr: string) {
  let url: URL;

  try {
    url = new URL(urlStr);
  } catch (_) {
    return false;
  }
  return url.protocol === 'https:';
}
